import React, { useState } from 'react';
import QueryHistory from './QueryHistory';
import FeedbackCorrections from './FeedbackCorrections';
import FeedbackDashboard from './FeedbackDashboard';
import LLMSettings from './LLMSettings';

const TABS = [
  { key: 'queries',     label: 'Query History',  icon: '📋' },
  { key: 'corrections', label: 'Corrections',    icon: '🔧' },
  { key: 'dashboard',   label: 'Dashboard',      icon: '📊' },
  { key: 'llm',         label: 'LLM Settings',   icon: '🤖' },
];

const DARK = {
  page: '#0f172a', surface: '#1e293b', border: '#334155',
  text: '#f1f5f9', textSecondary: '#94a3b8', textMuted: '#64748b',
  activeBg: '#2563eb', activeText: '#ffffff', hoverBg: '#162032',
};
const LIGHT = {
  page: '#f8fafc', surface: '#ffffff', border: '#e2e8f0',
  text: '#0f172a', textSecondary: '#475569', textMuted: '#94a3b8',
  activeBg: '#2563eb', activeText: '#ffffff', hoverBg: '#f1f5f9',
};

const AdminShell = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState('queries');
  const [dark, setDark] = useState(true);
  const t = dark ? DARK : LIGHT;

  return (
    <div style={{ minHeight: '100vh', background: t.page, color: t.text,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif' }}>

      {/* Top nav */}
      <div style={{ background: t.surface, borderBottom: `1px solid ${t.border}`,
        padding: '0 32px', position: 'sticky', top: 0, zIndex: 20, backdropFilter: 'blur(12px)' }}>
        <div style={{ maxWidth: 1400, margin: '0 auto', display: 'flex', flexDirection: 'column' }}>

          {/* Row 1: Back + Title + Theme */}
          <div style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
              <button onClick={onBack} style={{ display: 'flex', alignItems: 'center', gap: 7,
                padding: '7px 16px', background: 'transparent', border: `1px solid ${t.border}`,
                borderRadius: 8, cursor: 'pointer', color: t.textSecondary, fontSize: 14, fontWeight: 500 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
                Back
              </button>
              <div style={{ width: 1, height: 28, background: t.border }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 36, height: 36, borderRadius: 10, background: '#2563eb',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
                  </svg>
                </div>
                <div>
                  <h1 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: t.text }}>Admin Panel</h1>
                  <p style={{ margin: 0, fontSize: 12, color: t.textMuted }}>Query History · Feedback · Corrections</p>
                </div>
              </div>
            </div>
            <button onClick={() => setDark(d => !d)}
              title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
              style={{ width: 42, height: 42, display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: dark ? '#162032' : '#f1f5f9', border: `1px solid ${t.border}`,
                borderRadius: 10, cursor: 'pointer', fontSize: 18, flexShrink: 0 }}>
              {dark ? '☀️' : '🌙'}
            </button>
          </div>

          {/* Row 2: Tabs */}
          <div style={{ display: 'flex', gap: 4, paddingBottom: 0 }}>
            {TABS.map(tab => {
              const isActive = activeTab === tab.key;
              return (
                <button key={tab.key} onClick={() => setActiveTab(tab.key)}
                  style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 20px',
                    background: isActive ? t.activeBg : 'transparent', border: 'none',
                    borderBottom: isActive ? '3px solid #3b82f6' : '3px solid transparent',
                    borderRadius: '8px 8px 0 0', cursor: 'pointer',
                    color: isActive ? t.activeText : t.textMuted,
                    fontSize: 14, fontWeight: isActive ? 600 : 500, transition: 'all 0.15s ease' }}
                  onMouseEnter={e => { if (!isActive) e.target.style.background = t.hoverBg; }}
                  onMouseLeave={e => { if (!isActive) e.target.style.background = 'transparent'; }}>
                  <span style={{ fontSize: 16 }}>{tab.icon}</span>
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Tab content */}
      <div>
        {activeTab === 'queries' && <QueryHistory onBack={onBack} embedded dark={dark} />}
        {activeTab === 'corrections' && <FeedbackCorrections dark={dark} />}
        {activeTab === 'dashboard' && <FeedbackDashboard dark={dark} />}
        {activeTab === 'llm' && <LLMSettings dark={dark} />}
      </div>
    </div>
  );
};

export default AdminShell;
